const Location = props => {
    return (
        <div className="location" id="location">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2952.2062965370546!2d42.70694331545354!3d42.27411947919271!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x405c8c5820893115%3A0xb536b6d1f77ab8fb!2sSynagogue!5e0!3m2!1sen!2sil!4v1636449059191!5m2!1sen!2sil" width="100%" height="450" style={{border: 0}} allowfullscreen="no" loading="lazy"></iframe>
        </div>
    )
}

export default Location
